<template>
  <div id="app">
   <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
}
</script>

<style>
@import url("./assets/iconfont/iconfont.css");
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
.hz-dialog--center {
  text-align: center;
}


</style>
